const GameFlowEvent = {};
export default GameFlowEvent;

GameFlowEvent.INTRO_COMPLETED = "GameFlowEvent.INTRO_COMPLETED";
GameFlowEvent.TRANSITION_TO_DIALOG = "GameFlowEvent.TRANSITION_TO_DIALOG";